// extracted by mini-css-extract-plugin
export default {"container":"AmountCurrencyInput_container__rixoS","amount":"AmountCurrencyInput_amount__CTcN7","currency":"AmountCurrencyInput_currency__A77Nv"};